import React, { useState, useEffect } from "react";

import { Button } from "react-bootstrap";

import PayeesList from "./screens/PayeesList";
import ChooseAccount from "./screens/ChooseAccount";
import ChoosePaymentAmount from "./screens/ChoosePaymentAmount";
import CheckFxRate from "./screens/CheckFxRate";
import Layout from "./components/Layout";
import Error from "./components/Error";
import Wait from "./components/Wait";
import AskIsCard from "./screens/AskIsCard";

import getSavedPayee from "./lib/getSavedPayee";
import getCurrencies from "./lib/getCurrencies";
import getSavedPayees from "./lib/getSavedPayees";
import submitPayment from "./lib/submitPayment";
import getFxRate from "./lib/getFxRate";
import submitSwiftPayment from "./lib/submitSwiftPayment";

function getPayeesPage() {
  if (!document.querySelector("#PaymentsWidget")) return null;
  if (!document.querySelector("#PaymentsWidget").getAttribute("payees_page"))
    return null;
  return document.querySelector("#PaymentsWidget").getAttribute("payees_page");
}

function DeepLinkBtn(props) {
  var link = props.link;
  if ( !link.endsWith("/")) link = link.concat("/");;

  return (
    <Button
      variant="dark"
      block
      // onClick={onClick}
      href={`${link}`}
      className="deeplink addpayee"
    >
      Or add a new Payee
    </Button>
  );
}

export default function App(props) {
  const initialCurrency = props.widget.getAttribute("initialCurrency") || null;

  const payees_page = getPayeesPage();
  const [screen, setScreen] = useState("ChooseAccount");
  const [error, setError] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const [payees, setPayees] = useState(null);
  const [purposeCodes, setPurposeCodes] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [currencies, setCurrencies] = useState(null);
  const [chosenPayee, setChosenPayee] = useState(null);
  const [rate, setRate] = useState(null);
  const [DebitAmount, setDebitAmount] = useState(null);
  const [PaymentAmount, setPaymentAmount] = useState(null);
  const [Reference, setReference] = useState(null);
  const [Purpose, setPurpose] = useState(null);
  const [waitingForPayee, setWaitingForPayee] = useState(true);
  const [RemittanceFee, setRemittanceFee] = useState(null);
  const [bankTransferResult, setBankTransferResult] = useState(null);
  const [isCard, setIsCard] = useState(null);
  const [askIsCard, setAskIsCard] = useState(null);

  function checkForPayeeId() {
    const urlParams = new window.URLSearchParams(window.location.search);
    const payeeId = urlParams.get("payee_id");
    const account = urlParams.get("account");
    if (payeeId) return { payeeId, account };

    const payee_id = document
      .querySelector("#PaymentsWidget")
      .getAttribute("payee_id");
    if (payee_id) return { payee_id };

    return false;
  }

  useEffect(() => {
    const { payeeId, account } = checkForPayeeId();
    if (!payeeId) return setWaitingForPayee(false);

    if (account) setCurrency(account);

    getSavedPayee(
      setChosenPayee,
      setScreen,
      setWaitingForPayee,
      setError,
      payeeId,
      setPurposeCodes,
      setAskIsCard
    );
    return;
  }, []);

  useEffect(() => {
    if (initialCurrency) {
      setCurrencies(initialCurrency === "EURO" ? [{name: "EUR"}] : [{name: initialCurrency}]);
      setShowOverlay(false);
      return;
    }
    getCurrencies(setCurrencies, setShowOverlay, setError);
  }, [initialCurrency]);

  if (error) return <Error />;

  // if (message)
  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         height: "100%",
  //         display: "grid",
  //         placeItems: "center",
  //       }}
  //     >
  //       <p>{message}</p>
  //     </div>
  //   );

  if (showOverlay || waitingForPayee) return <Wait />;

  // deal with case when a payee_id is used to put the customer straight on the Payment screen
  if (screen === "ChooseAccount" || (screen === "PayeesList" && !payees)) {
    if (currencies.length === 1) {
      setCurrency(currencies[0].name);
      // getSavedPayees(currencies[0]);
      getSavedPayees(
        currencies[0].name,
        setShowOverlay,
        setPayees,
        setScreen,
        setPurposeCodes,
        setError
      );
      return <></>;
    }

    return (
      <Layout header={"Please choose an account"}>
        <div className="button-group">
          <ChooseAccount
            currencies={currencies}
            onClick={(selected_currency) => {
              setCurrency(selected_currency.name);
              setIsCard(selected_currency.isCard);
              // getSavedPayees(x);
              getSavedPayees(
                selected_currency.name,
                setShowOverlay,
                setPayees,
                setScreen,
                setPurposeCodes,
                setError
              );
            }}
          />
          {payees_page && <DeepLinkBtn link={payees_page} />}
        </div>
      </Layout>
    );
  }

  if (screen === "PayeesList" && payees.length === 0)
    return (
      <Layout
        header={"You have no saved payees"}
        goBack={
          currencies.length === 1 ? false : () => setScreen("ChooseAccount")
        }
      >
        <p>A Payee needs to be created before making a payment.</p>
        <div className="payee-group">
          <DeepLinkBtn link={payees_page} />
        </div>
      </Layout>
    );

  if (screen === "PayeesList"){
    return (
      <Layout
        header={"Choose payee"}
        goBack={
          currencies.length === 1 ? false : () => setScreen("ChooseAccount")
        }
      >
        <div className="payee-group">
          <PayeesList
            payees={payees}
            onClick={(x) => {
              setChosenPayee(x);
              setScreen("Payment");
            }}
          />
          <DeepLinkBtn link={payees_page} />
        </div>
      </Layout>
    );
  }

  function getTransferType(
    transfer_type,
    beneficiaryCurrency,
    accountCurrency
  ) {
    if (transfer_type) return transfer_type;
    if (chosenPayee.details.Currency === accountCurrency) return "LOCAL";
    return "SWIFT";
  }

  const transfer_type = getTransferType(
    chosenPayee.transfer_type,
    chosenPayee.details.beneficiaryCurrency,
    currency
  );

if(askIsCard){
  return <AskIsCard setAskIsCard={setAskIsCard} setIsCard={setIsCard}/>;
}

  if (transfer_type !== "SWIFT" && screen === "Payment") {
    return (
      <Layout header={"Payment Details"} goBack={() => setScreen("PayeesList")}>
        <ChoosePaymentAmount
          details={chosenPayee.details}
          purposeCodes={purposeCodes}
          buttonText={"Submit"}
          RemittanceFee={RemittanceFee + " " + currency}
          submitEvent={(PaymentAmount, Reference, Purpose) => {
            submitPayment(
              PaymentAmount,
              Reference,
              Purpose,
              setBankTransferResult,
              setScreen,
              setShowOverlay,
              chosenPayee,
              setError,
              isCard
            );
          }}
        />
      </Layout>
    );
  }

  if (screen === "Payment") {
    return (
      <Layout header={"Payment Details"} goBack={() => setScreen("PayeesList")}>
        <ChoosePaymentAmount
          details={chosenPayee.details}
          purposeCodes={purposeCodes}
          buttonText={"Check FX rate"}
          RemittanceFee={RemittanceFee + " " + currency}
          submitEvent={(PaymentAmount, Reference, Purpose) => {
            setPaymentAmount(PaymentAmount);
            setReference(Reference);
            setPurpose(Purpose);
            getFxRate(
              PaymentAmount,
              setRate,
              setDebitAmount,
              setRemittanceFee,
              setScreen,
              setShowOverlay,
              chosenPayee,
              currency,
              setError
            );
            // setPurpose(purposeVal);
          }}
        />
      </Layout>
    );
  }

  if (screen === "ConfirmFxRate")
    return (
      <Layout
        header={"Confirm Foreign Exchange Rate"}
        goBack={() => setScreen("Payment")}
      >
        <CheckFxRate
          currencyFrom={currency}
          currencyTo={chosenPayee.details.Currency}
          DebitAmount={DebitAmount}
          rate={rate}
          PaymentAmount={PaymentAmount}
          RemittanceFee={currency + " " + RemittanceFee}
          // submit_function={() => submitSwiftPayment()}
          submit_function={() =>
            submitSwiftPayment(
              setBankTransferResult,
              setScreen,
              setShowOverlay,
              chosenPayee,
              PaymentAmount,
              Reference,
              DebitAmount,
              currency,
              Purpose,
              setError,
              isCard
            )
          }
        />
      </Layout>
    );

  function getMessage(transfer_type, bankTransferResult) {
    if (bankTransferResult.status === "failure")
      return <div className="message fail">{bankTransferResult.message}</div>;
    if (transfer_type === "SWIFT")
      return (
        <div className="message success processing">
          Your bank transfer was successfully received and will now be
          processed.
        </div>
      );
    return (
      <div className="message success">Your bank transfer was successful.</div>
    );
  }

  return (
    <Layout
      goBack={() => setScreen("PayeesList")} // need to choose currency if using initial payee_id
      goBackText={"Back To Payees"}
    >
      {getMessage(transfer_type, bankTransferResult)}
    </Layout>
  );
}
